import * as yup from 'yup';

export const openingDateFormSchema = yup.object().shape({
  startDate: yup.string().required('maintenance.opening_dates.form.start_date.required'),
  endDate: yup.string().required('maintenance.opening_dates.form.end_date.required'),
  evaluationId: yup.string().required('maintenance.opening_dates.form.evaluation_id.required'),
});
